
import * as d3 from 'd3';
import { useEffect, useRef } from 'react';
import { tip as d3tip } from "d3-v6-tip";
import num2month from '../data_processor/num2month_convertor';

// var screen_width_fac = 0.675;
// var screen_height_fac = 0.6;
var screen_width_fac = 0.875;
var screen_height_fac = 0.555;

var colorZeroDivisor = 'black';

Array.prototype.pushIfNotExist_SEX = function(element, comparer) { 
    if (!this.inArray(comparer)) {
        this.push(element.SEX);
    }
}; 

Array.prototype.groupBy = function (props) {
    var arr = this;
    var partialResult = {};
    
    arr.forEach(el=>{
    
        var grpObj = {};
        
        props.forEach(prop=>{
              grpObj[prop] = el[prop]
        });
        
        var key = JSON.stringify(grpObj);
        
        if(!partialResult[key]) partialResult[key] = [];
        
        partialResult[key].push(el);
        
    });
    
    var finalResult = Object.keys(partialResult).map(key=>{
       var keyObj = JSON.parse(key);
       keyObj.values = partialResult[key];
       return keyObj;
    })
    
    return finalResult;
 }

 function containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
        if (list[i].label === obj.label) {
            return true;
        }
    }

    return false;
}

const View3_G1 = (props) => {
    
    const svgRef1 = useRef();
    const xAxisRef1 = useRef();
    const yAxisRef1 = useRef();
    const graphRef1 = useRef();

    const toolTipRef1 = useRef();
    const mouseGRef1 = useRef();
    const mouseLineRef1 = useRef();
    const rectRef1 = useRef();

    const lineStroke_mouse = "2px";

    const tooltip1 = d3.select(toolTipRef1.current)
        .attr('id', 'tooltip1')
        .style('position', 'absolute')
        .style("background-color", "#FFFFFF")
        .style('padding', 6)
        .style('display', 'none');

    const mouseG = d3.select(mouseGRef1.current);
    const mouseLine1 = d3.select(mouseLineRef1.current);
    const rect = d3.select(rectRef1.current);

    const graph = d3.select(graphRef1.current);

    d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y %y",
        "date": "%d.%m.%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
        "shortDays": ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        "months": ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
        "shortMonths": ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
      });
    
    useEffect(() => {
        if(props.graphData && props.graphData.length != 0){
            const {margin, graphWidth, graphHeight, x, y, xAxisGroup, yAxisGroup} = draw();
            update(props.graphData, x, y, xAxisGroup, yAxisGroup, props.selectedTimeFormat, graphHeight, graphWidth);
        } else {
            cleanGraph();
        }

        
    }, [props.graphData]);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function updateTooltipContent(event, mouse, nestedData, color, x, timeFormat) {
        // const spaceX = 300;
        const spaceX = window.innerWidth*0.2;
        var spaceY = 50;
        let sortingObj = [];

        var shift_tooltip_l,shift_tooltip_r;
        
        if(window.innerWidth > 1440){
            shift_tooltip_r = 0.75;
            shift_tooltip_l = -0.2;
        } else {
            shift_tooltip_r = 0.75;
            shift_tooltip_l = -0.2;
        }

            nestedData.map(d => {
                const data_array = d.values;
                var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                var bisect = d3.bisector(function (data_array) {
                            return data_array.engDate; 
                        }).left // retrieve row index of date on parsed csv
                var idx = bisect(d.values, xDate);
                if(data_array[idx] != undefined){
                    sortingObj.push({"key": data_array[idx]['SEX'], "Excess Death Number": data_array[idx]['Excess Death Number'],
                     "Age": data_array[idx]['AGE_GROUP'], "Date": data_array[idx]['Date'], "Week": data_array[idx]['DWEEK'],
                      "Month": data_array[idx]['DMON']-1, "Year": data_array[idx]['DYEAR']})
                }
            });
            sortingObj.sort(function(x, y){
               return d3.descending(x['Excess Death Number'], y['Excess Death Number']);
            })
    
            var sortingArr = sortingObj.map(d => d.key);
    
            var nestedData1 = nestedData.slice().sort(function(a, b){
              return sortingArr.indexOf(a.key) - sortingArr.indexOf(b.key) // rank vehicle category based on price of premium
            })

            let nestedDataTemp = [...nestedData1 ];

            nestedDataTemp = nestedDataTemp.sort(function (a, b) {
                return  b.AGE_GROUP ? a.AGE_GROUP.localeCompare(b.AGE_GROUP) : -1;          
            });

            nestedData1 = nestedDataTemp.sort(function (a, b) {
                if(a.SEX === undefined){
                    return 1;
                } else {
                    return  b.SEX ? a.SEX.localeCompare(b.SEX) : -1;  
                } 
                // return  b.SEX ? a.SEX.localeCompare(b.SEX) : -1;          
            });

            if(sortingObj[0] != undefined){
                // const regex = /[0-9][0-9]:[0-9][0-9]:[0-9][0-9] น./g;
                // const time = sortingObj[0]['Date'].match(regex);
                // var date = sortingObj[0]['Date'].replace(time,'');
                var month = num2month(sortingObj[0]['Month']);
                var year = sortingObj[0]['Year'];
                var week = sortingObj[0]['Week'];
            }
            if(timeFormat === 'เดือน'){
                if(event.pageX >= window.screen.width*0.60){
                    let gender_list = [];
                    tooltip1.html("<p><strong>" + month + " " + year + "</strong></p>")
                    .style('display', 'block')
                    .style('left', event.pageX - shift_tooltip_r*spaceX + "px")
                    .style('top', event.pageY - spaceY + "px")
                    .style('font-size', 11.5)
                    .selectAll()
                    .data(nestedData1).enter() // for each vehicle category, list out name and price of premium
                    .append('div')
                    .style('color', (d,i) => {
                        return color(d.AGE_GROUP);
                    })
                    .style('font-size', 10)
                    .html(d => {
                        const data_array = d.values;
                        var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                        var bisect = d3.bisector(function (data_array) {
                                    return data_array.engDate; 
                                }).left // retrieve row index of date on parsed csv
                        var idx = bisect(d.values, xDate);
                        if(data_array[idx] != undefined){
                            // var age_str = data_array[idx]['AGE_GROUP'];
                            // var extract_age_num = age_str.substring(4, age_str.length);
                            // var age_tooltip = ` อายุ ${extract_age_num} : `;
                            // if(parseInt(extract_age_num) === 0){
                            //     age_tooltip = ' อายุน้อยกว่า 1 ปี : ';
                            // } 
                            if(gender_list.includes(data_array[idx]['SEX'])){
                                return '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            } else {
                                gender_list.pushIfNotExist_SEX(d, function(e) { 
                                    return e === d.SEX; 
                                });
                                var sex; 
                                if (data_array[idx]['SEX'] === undefined){
                                    sex = 'รวมทั้งสองเพศ';
                                } else if (data_array[idx]['SEX'] === 'ชาย'){
                                    sex = 'เพศชาย';
                                } else {
                                    sex = 'เพศหญิง';
                                }
                                return `<b class="gender_label">${sex}</b>`+
                                '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            }
                            // return 'เพศ'+data_array[idx]['SEX'] + age_tooltip + (Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100).toString();
                        } else {
                            d3.selectAll("#tooltip1")
                            .style('display', 'none');
                        }
                    }); 
                } else {
                    let gender_list = [];
                    tooltip1.html("<p><strong>" + month + " " + year + "</strong></p>")
                    .style('display', 'block')
                    .style('left', event.pageX - shift_tooltip_l*spaceX + "px")
                    .style('top', event.pageY - spaceY + "px")
                    .style('font-size', 11.5)
                    .selectAll()
                    .data(nestedData1).enter() // for each vehicle category, list out name and price of premium
                    .append('div')
                    .style('color', (d,i) => {
                        return color(d.AGE_GROUP);
                    })
                    .style('font-size', 10)
                    .html(d => {
                        const data_array = d.values;
                        var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                        var bisect = d3.bisector(function (data_array) {
                                    return data_array.engDate; 
                                }).left // retrieve row index of date on parsed csv
                        var idx = bisect(d.values, xDate);
                        if(data_array[idx] != undefined){
                            // var age_str = data_array[idx]['AGE_GROUP'];
                            // var extract_age_num = age_str.substring(4, age_str.length);
                            // var age_tooltip = ` อายุ ${extract_age_num} : `;
                            // if(parseInt(extract_age_num) === 0){
                            //     age_tooltip = ' อายุน้อยกว่า 1 ปี : ';
                            // } 
                            if(gender_list.includes(data_array[idx]['SEX'])){
                                return '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            } else {
                                gender_list.pushIfNotExist_SEX(d, function(e) { 
                                    return e === d.SEX; 
                                });
                                var sex; 
                                if (data_array[idx]['SEX'] === undefined){
                                    sex = 'รวมทั้งสองเพศ';
                                } else if (data_array[idx]['SEX'] === 'ชาย'){
                                    sex = 'เพศชาย';
                                } else {
                                    sex = 'เพศหญิง';
                                }
                                return `<b class="gender_label">${sex}</b>`+
                                '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            }
                            // return 'เพศ'+data_array[idx]['SEX'] + age_tooltip + (Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100).toString();
                        } else {
                            d3.selectAll("#tooltip1")
                            .style('display', 'none');
                        }
                    }); 
                }
            } else if(timeFormat === 'สัปดาห์'){
                if(event.pageX >= window.screen.width*0.60){
                    let gender_list = [];
                    tooltip1.html("<p><strong>" + "สัปดาห์ที่ " + week + ", " + month + " " + year + "</strong></p>")
                    .style('display', 'block')
                    .style('left', event.pageX - shift_tooltip_r*spaceX + "px")
                    .style('top', event.pageY - spaceY + "px")
                    .style('font-size', 11.5)
                    .selectAll()
                    .data(nestedData1).enter() // for each vehicle category, list out name and price of premium
                    .append('div')
                    .style('color', (d,i) => {
                        return color(d.AGE_GROUP);
                    })
                    .style('font-size', 10)
                    .html(d => {
                        const data_array = d.values;
                        var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                        var bisect = d3.bisector(function (data_array) {
                                    return data_array.engDate; 
                                }).left // retrieve row index of date on parsed csv
                        var idx = bisect(d.values, xDate);
                        if(data_array[idx] != undefined){
                            // var age_str = data_array[idx]['AGE_GROUP'];
                            // var extract_age_num = age_str.substring(4, age_str.length);
                            // var age_tooltip = ` อายุ ${extract_age_num} : `;
                            // if(parseInt(extract_age_num) === 0){
                            //     age_tooltip = ' อายุน้อยกว่า 1 ปี : ';
                            // } 
                            if(gender_list.includes(data_array[idx]['SEX'])){
                                return '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            } else {
                                gender_list.pushIfNotExist_SEX(d, function(e) { 
                                    return e === d.SEX; 
                                });
                                var sex; 
                                if (data_array[idx]['SEX'] === undefined){
                                    sex = 'รวมทั้งสองเพศ';
                                } else if (data_array[idx]['SEX'] === 'ชาย'){
                                    sex = 'เพศชาย';
                                } else {
                                    sex = 'เพศหญิง';
                                }
                                return `<b class="gender_label">${sex}</b>`+
                                '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            }
                            // return 'เพศ'+data_array[idx]['SEX'] + age_tooltip + (Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100).toString();
                        } else {
                            d3.selectAll("#tooltip1")
                            .style('display', 'none');
                        }
                    }); 
                } else {
                    let gender_list = [];
                    tooltip1.html("<p><strong>" + "สัปดาห์ที่ " + week + ", " + month + " " + year + "</strong></p>")
                    .style('display', 'block')
                    .style('left', event.pageX - shift_tooltip_l*spaceX + "px")
                    .style('top', event.pageY - spaceY + "px")
                    .style('font-size', 11.5)
                    .selectAll()
                    .data(nestedData1).enter() // for each vehicle category, list out name and price of premium
                    .append('div')
                    .style('color', (d,i) => {
                        return color(d.AGE_GROUP);
                    })
                    .style('font-size', 10)
                    .html(d => {
                        const data_array = d.values;
                        var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                        var bisect = d3.bisector(function (data_array) {
                                    return data_array.engDate; 
                                }).left // retrieve row index of date on parsed csv
                        var idx = bisect(d.values, xDate);
                        if(data_array[idx] != undefined){
                            // var age_str = data_array[idx]['AGE_GROUP'];
                            // var extract_age_num = age_str.substring(4, age_str.length);
                            // var age_tooltip = ` อายุ ${extract_age_num} : `;
                            // if(parseInt(extract_age_num) === 0){
                            //     age_tooltip = ' อายุน้อยกว่า 1 ปี : ';
                            // } 
                            if(gender_list.includes(data_array[idx]['SEX'])){
                                return '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            } else {
                                gender_list.pushIfNotExist_SEX(d, function(e) { 
                                    return e === d.SEX; 
                                });
                                var sex; 
                                if (data_array[idx]['SEX'] === undefined){
                                    sex = 'รวมทั้งสองเพศ';
                                } else if (data_array[idx]['SEX'] === 'ชาย'){
                                    sex = 'เพศชาย';
                                } else {
                                    sex = 'เพศหญิง';
                                }
                                return `<b class="gender_label">${sex}</b>`+
                                '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            }
                            // return 'เพศ'+data_array[idx]['SEX'] + age_tooltip + (Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100).toString();
                        } else {
                            d3.selectAll("#tooltip1")
                            .style('display', 'none');
                        }
                    }); 
                }
            } else if(timeFormat === 'ปี'){ 
                if(event.pageX >= window.screen.width*0.60){
                    let gender_list = [];
                    tooltip1.html("<p><strong>" + "ปี "+ year + "</strong></p>")
                    .style('display', 'block')
                    .style('left', event.pageX - shift_tooltip_r*spaceX + "px")
                    .style('top', event.pageY - spaceY + "px")
                    .style('font-size', 11.5)
                    .selectAll()
                    .data(nestedData1).enter() // for each vehicle category, list out name and price of premium
                    .append('div')
                    .style('color', (d,i) => {
                        return color(d.AGE_GROUP);
                    })
                    .style('font-size', 10)
                    .html(d => {
                        const data_array = d.values;
                        var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                        var bisect = d3.bisector(function (data_array) {
                                    return data_array.engDate; 
                                }).left // retrieve row index of date on parsed csv
                        var idx = bisect(d.values, xDate);
                        if(data_array[idx] != undefined){
                            // var age_str = data_array[idx]['AGE_GROUP'];
                            // var extract_age_num = age_str.substring(4, age_str.length);
                            // var age_tooltip = ` อายุ ${extract_age_num} : `;
                            // if(parseInt(extract_age_num) === 0){
                            //     age_tooltip = ' อายุน้อยกว่า 1 ปี : ';
                            // } 
                            if(gender_list.includes(data_array[idx]['SEX'])){
                                return '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            } else {
                                gender_list.pushIfNotExist_SEX(d, function(e) { 
                                    return e === d.SEX; 
                                });
                                var sex; 
                                if (data_array[idx]['SEX'] === undefined){
                                    sex = 'รวมทั้งสองเพศ';
                                } else if (data_array[idx]['SEX'] === 'ชาย'){
                                    sex = 'เพศชาย';
                                } else {
                                    sex = 'เพศหญิง';
                                }
                                return `<b class="gender_label">${sex}</b>`+
                                '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            }
                            // return 'เพศ'+data_array[idx]['SEX'] + age_tooltip + (Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100).toString();
                        } else {
                            d3.selectAll("#tooltip1")
                            .style('display', 'none');
                        }
                    }); 
                } else {
                    let gender_list = [];
                    tooltip1.html("<p><strong>" + "ปี "+ year + "</strong></p>")
                    .style('display', 'block')
                    .style('left', event.pageX - shift_tooltip_l*spaceX + "px")
                    .style('top', event.pageY - spaceY + "px")
                    .style('font-size', 11.5)
                    .selectAll()
                    .data(nestedData1).enter() // for each vehicle category, list out name and price of premium
                    .append('div')
                    .style('color', (d,i) => {
                        return color(d.AGE_GROUP);
                    })
                    .style('font-size', 10)
                    .html(d => {
                        const data_array = d.values;
                        var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                        var bisect = d3.bisector(function (data_array) {
                                    return data_array.engDate; 
                                }).left // retrieve row index of date on parsed csv
                        var idx = bisect(d.values, xDate);
                        if(data_array[idx] != undefined){
                            // var age_str = data_array[idx]['AGE_GROUP'];
                            // var extract_age_num = age_str.substring(4, age_str.length);
                            // var age_tooltip = ` อายุ ${extract_age_num} : `;
                            // if(parseInt(extract_age_num) === 0){
                            //     age_tooltip = ' อายุน้อยกว่า 1 ปี : ';
                            // } 
                            if(gender_list.includes(data_array[idx]['SEX'])){
                                return '<li>'+data_array[idx]['AGE_GROUP']+ " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            } else {
                                gender_list.pushIfNotExist_SEX(d, function(e) { 
                                    return e === d.SEX; 
                                });
                                var sex; 
                                if (data_array[idx]['SEX'] === undefined){
                                    sex = 'รวมทั้งสองเพศ';
                                } else if (data_array[idx]['SEX'] === 'ชาย'){
                                    sex = 'เพศชาย';
                                } else {
                                    sex = 'เพศหญิง';
                                }
                                return `<b class="gender_label">${sex}</b>`+
                                '<li>'+data_array[idx]['AGE_GROUP'] + " : " + numberWithCommas(Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100)+'</li>';
                            }
                            // return 'เพศ'+data_array[idx]['SEX'] + age_tooltip + (Math.round((data_array[idx]['Excess Death Number'] + Number.EPSILON) * 100) / 100).toString();
                        } else {
                            d3.selectAll("#tooltip1")
                            .style('display', 'none');
                        }
                    }); 
                }
            } 
      }

    const draw = () => {

        const margin = {top: 50, right: 100, bottom: 50, left: 50};
        const graphWidth = window.innerWidth*screen_width_fac - margin.left - margin.right;
        const graphHeight = window.innerHeight*screen_height_fac - margin.top - margin.bottom;

        // scales
        const x = d3.scaleTime()
            .range([0,graphWidth]);

        const y = d3.scaleLinear()
            .range([graphHeight, 0]);

        // axes groups
        const xAxisGroup = d3.select(xAxisRef1.current)

        xAxisGroup.attr('transform', `translate(0, ${graphHeight})`);
        
        const yAxisGroup = d3.select(yAxisRef1.current)
        yAxisGroup.attr('transform', `translate(0, 0)`);
        
            return {margin, graphWidth, graphHeight, x, y, xAxisGroup, yAxisGroup}
        }
    const cleanGraph = () => {

        graph.selectAll('.dashed')
            .remove();

        graph.selectAll('.solid')
            .remove();

        graph.selectAll('.datapoint_all')
            .remove();

        graph.selectAll('.datapoint_all_inner')
            .remove();

        graph.selectAll('.datapoint_male')
            .remove();

        graph.selectAll('.datapoint_female')
            .remove();

        graph.selectAll('.zero-divider')
            .remove();

        graph.selectAll('.year-divider')
            .remove();
    
        graph.selectAll('.year-divider-label')
            .remove();
    }
    
    const update = (graphData, x, y, xAxisGroup, yAxisGroup, selectedTimeFormat, graphHeight, graphWidth) => {

    // const color = d3.scaleOrdinal(d3.schemeTableau10).domain(props.ageData);
    const color = d3.scaleOrdinal(d3.schemeTableau10);
    const nestedData = graphData.groupBy(['SEX','AGE_GROUP']);
    const genderData = d3.groups(graphData, d => d.SEX);
    const nestedData_dummy = [{"dummy": {}}];
    let colorProvince = [];

    const yearStringStarted = [`January 1, ${props.selectedYear} 00:00:00`,`January 1, ${props.selectedYear+1} 00:00:00`];
    const yearString = [`January 1, ${props.selectedYear+1} 00:00:00`];
    const yearStringExtra = [`January 1, ${props.selectedYear+1} 00:00:00`,`January 1, ${props.selectedYear+2} 00:00:00`,
    `January 1, ${props.selectedYear+3} 00:00:00`];
    
    const yearDivLabelStarted = [props.selectedYear,props.selectedYear+1];
    const yearDivLabel = [props.selectedYear+1];
    const yearDivLabelExtra = [props.selectedYear+1,props.selectedYear+2,props.selectedYear+3];

    nestedData.forEach((d,i) => {
        // var age_str = d.AGE_GROUP;
        // var extract_age_num = age_str.substring(4, age_str.length);
        // var age_tooltip = ` อายุ ${extract_age_num}`;
        // if(parseInt(extract_age_num) === 0){
        //     age_tooltip = ' อายุน้อยกว่า 1 ปี';
        // }
        let temp = {'label': `${d.AGE_GROUP}`, 'color': color(d.AGE_GROUP)};
        if(colorProvince.length === 0){
            colorProvince.push(temp);
        }
        else if(colorProvince.length > 0 && !(containsObject(temp, colorProvince))){
            colorProvince.push(temp);
        }
    });

    props.onChange(colorProvince);

    const lineOpacity = "0.8";
    const lineOpacityHover = "0.9";
    const otherLinesOpacityHover = "0.1";
    const lineStroke = "2.5px";
    const lineStrokeHover = "2.5px";

    const circleOpacity = "0.8";
    const circleOpacityOnLineHover = "0.25";
    let colorScheme = []; 

    mouseG.attr("class", "mouse-over-effects-1");

    mouseLine1.attr("class", "mouse-line-1")
        .style("stroke", "#A9A9A9")
        .style("stroke-width", lineStroke)
        .style("opacity", "0");

    nestedData.forEach((data,index) => {
        data.values.forEach((inner, innerIndex) => {
            colorScheme.push(color(inner.AGE_GROUP));
        });
    });

    const mousePerLine = mouseG.selectAll('.mouse-per-line-1')
        .data(nestedData)
        .join("g")
        .attr("class", "mouse-per-line-1");
    
    const dateRange = d3.extent(graphData, d => new Date(d.engDate));

    if(selectedTimeFormat === 'เดือน'){
        var xAxis = d3.axisBottom(x)
        .ticks(graphData.length)
        .tickFormat(d3.timeFormat("%b"))
        .ticks(d3.timeMonth.every(1))
        .tickSizeOuter(0);

        var yAxis = d3.axisLeft(y)
        .ticks(7)
        .tickFormat(d => numberWithCommas(d))
        .tickSize(-graphWidth)
        .tickSizeOuter(0);

        x.domain([new Date(dateRange[0].setDate(dateRange[0].getDate()-30)), new Date(dateRange[1].setDate(dateRange[1].getDate()+30))]);
        if(d3.min(graphData, d => d['Excess Death Number']) < 0){
            y.domain([(d3.min(graphData, d => d['Excess Death Number']))*1.1, d3.max(graphData, d => d['Excess Death Number'])*1.2]);
        } else {
            y.domain([(d3.min(graphData, d => d['Excess Death Number']))*0.9, d3.max(graphData, d => d['Excess Death Number'])*1.2]);
        }

        if(d3.min(graphData, d => d['Excess Death Number']) < 0 && !(d3.min(graphData, d => d['Excess Death Number']) > 0)){
            graph.selectAll('.zero-divider')
            .data(yearStringStarted[yearStringStarted.length-1])
            .join('line')
            .attr('class', 'zero-divider')
            .attr('x1', 0)
            .attr('y1', y(0))
            .attr('x2', graphWidth)
            .attr('y2', y(0))
            .attr('stroke', colorZeroDivisor);
        } else {
            graph.selectAll('.zero-divider')
            .remove();
        }
        // if(d3.min(graphData, d => d['Excess Death Number']) === 0){
        //     graph.selectAll('.zero-divider')
        //     .remove();
        // }
        // else {
        //     graph.selectAll('.zero-divider')
        //     .data(yearStringStarted[yearStringStarted.length-1])
        //     .join('line')
        //     .attr('class', 'zero-divider')
        //     .attr('x1', 0)
        //     .attr('y1', y(0))
        //     .attr('x2', graphWidth)
        //     .attr('y2', y(0))
        //     .attr('stroke', colorZeroDivisor);
        // }

        if (props.selectedMonth === 1){
            graph.selectAll('.year-divider')
            .data(yearStringStarted)
            .join('line')
            .attr('class', 'year-divider')
            .attr('x1', d => x(new Date(d)))
            .attr('y1', graphHeight)
            .attr('x2', d => x(new Date(d)))
            .attr('y2', 0)
            .attr('stroke', '#b8b8b8');

            graph.selectAll('.year-divider-label')
                .data(yearDivLabelStarted)
                .join('text')
                .attr('class', 'year-divider-label')
                .text(d => d)
                .attr('x', (d,i) => x(new Date(yearStringStarted[i]))+8)
                .attr('y', 12);
        } else if(props.selectedMonth <= 11){
            graph.selectAll('.year-divider')
            .data(yearString)
            .join('line')
            .attr('class', 'year-divider')
            .attr('x1', d => x(new Date(d)))
            .attr('y1', graphHeight)
            .attr('x2', d => x(new Date(d)))
            .attr('y2', 0)
            .attr('stroke', '#b8b8b8');

            graph.selectAll('.year-divider-label')
                .data(yearDivLabel)
                .join('text')
                .attr('class', 'year-divider-label')
                .text(d => d)
                .attr('x', (d,i) => x(new Date(yearString[i]))+8)
                .attr('y', 12);
        } else {
            graph.selectAll('.year-divider')
            .data(yearStringExtra)
            .join('line')
            .attr('class', 'year-divider')
            .attr('x1', d => x(new Date(d)))
            .attr('y1', graphHeight)
            .attr('x2', d => x(new Date(d)))
            .attr('y2', 0)
            .attr('stroke', '#b8b8b8');

            graph.selectAll('.year-divider-label')
                .data(yearDivLabelExtra)
                .join('text')
                .attr('class', 'year-divider-label')
                .text(d => d)
                .attr('x', (d,i) => x(new Date(yearStringExtra[i]))+8)
                .attr('y', 12);
        }
    } else if(selectedTimeFormat === 'สัปดาห์'){ 
        var xAxis = d3.axisBottom(x)
        .ticks(graphData.length)
        .tickFormat(d3.timeFormat("%V"))
        .ticks(d3.timeWeek.every(5))
        .tickSizeOuter(0);
        
        var yAxis = d3.axisLeft(y)
        .ticks(7)
        .tickFormat(d =>  numberWithCommas(d))
        .tickSize(-graphWidth)
        .tickSizeOuter(0);

        x.domain([new Date(dateRange[0].setDate(dateRange[0].getDate()-30)), new Date(dateRange[1].setDate(dateRange[1].getDate()+30))]);
        if(d3.min(graphData, d => d['Excess Death Number']) < 0){
            y.domain([(d3.min(graphData, d => d['Excess Death Number']))*1.1, d3.max(graphData, d => d['Excess Death Number'])*1.2]);
        } else {
            y.domain([(d3.min(graphData, d => d['Excess Death Number']))*0.9, d3.max(graphData, d => d['Excess Death Number'])*1.2]);
        }

        if(d3.min(graphData, d => d['Excess Death Number']) < 0 && !(d3.min(graphData, d => d['Excess Death Number']) > 0)){
            graph.selectAll('.zero-divider')
            .data(yearStringStarted[yearStringStarted.length-1])
            .join('line')
            .attr('class', 'zero-divider')
            .attr('x1', 0)
            .attr('y1', y(0))
            .attr('x2', graphWidth)
            .attr('y2', y(0))
            .attr('stroke', colorZeroDivisor);
        } else {
            graph.selectAll('.zero-divider')
            .remove();
        }
        // if(d3.min(graphData, d => d['Excess Death Number']) === 0){
        //     graph.selectAll('.zero-divider')
        //     .remove();
        // }
        // else {
        //     graph.selectAll('.zero-divider')
        //     .data(yearStringStarted[yearStringStarted.length-1])
        //     .join('line')
        //     .attr('class', 'zero-divider')
        //     .attr('x1', 0)
        //     .attr('y1', y(0))
        //     .attr('x2', graphWidth)
        //     .attr('y2', y(0))
        //     .attr('stroke', colorZeroDivisor);
        // }

        if (props.selectedMonth === 1){
            graph.selectAll('.year-divider')
            .data(yearStringStarted)
            .join('line')
            .attr('class', 'year-divider')
            .attr('x1', d => x(new Date(d)))
            .attr('y1', graphHeight)
            .attr('x2', d => x(new Date(d)))
            .attr('y2', 0)
            .attr('stroke', '#b8b8b8');

            graph.selectAll('.year-divider-label')
                .data(yearDivLabelStarted)
                .join('text')
                .attr('class', 'year-divider-label')
                .text(d => d)
                .attr('x', (d,i) => x(new Date(yearStringStarted[i]))+8)
                .attr('y', 12);
        } else if(props.selectedMonth <= 11){
            graph.selectAll('.year-divider')
            .data(yearString)
            .join('line')
            .attr('class', 'year-divider')
            .attr('x1', d => x(new Date(d)))
            .attr('y1', graphHeight)
            .attr('x2', d => x(new Date(d)))
            .attr('y2', 0)
            .attr('stroke', '#b8b8b8');

            graph.selectAll('.year-divider-label')
                .data(yearDivLabel)
                .join('text')
                .attr('class', 'year-divider-label')
                .text(d => d)
                .attr('x', (d,i) => x(new Date(yearString[i]))+8)
                .attr('y', 12);
        } else {
            graph.selectAll('.year-divider')
            .data(yearStringExtra)
            .join('line')
            .attr('class', 'year-divider')
            .attr('x1', d => x(new Date(d)))
            .attr('y1', graphHeight)
            .attr('x2', d => x(new Date(d)))
            .attr('y2', 0)
            .attr('stroke', '#b8b8b8');

            graph.selectAll('.year-divider-label')
                .data(yearDivLabelExtra)
                .join('text')
                .attr('class', 'year-divider-label')
                .text(d => d)
                .attr('x', (d,i) => x(new Date(yearStringExtra[i]))+8)
                .attr('y', 12);
        }
    } else if(selectedTimeFormat === 'ปี'){
        var xAxis = d3.axisBottom(x)
        .ticks(props.availableYear.uniqueDateYearGenderAge.length)
        .tickFormat(d3.timeFormat("%Y"))
        .tickSizeOuter(0);
        
        var yAxis = d3.axisLeft(y)
        .ticks(7)
        .tickFormat(d => numberWithCommas(d))
        .tickSize(-graphWidth)
        .tickSizeOuter(0);

        x.domain([new Date(dateRange[0].setDate(dateRange[0].getDate()-30)), new Date(dateRange[1].setDate(dateRange[1].getDate()+30))]);
        if(d3.min(graphData, d => d['Excess Death Number']) < 0){
            y.domain([(d3.min(graphData, d => d['Excess Death Number']))*1.1, d3.max(graphData, d => d['Excess Death Number'])*1.2]);
        } else {
            y.domain([(d3.min(graphData, d => d['Excess Death Number']))*0.9, d3.max(graphData, d => d['Excess Death Number'])*1.2]);
        }
        
        if(d3.min(graphData, d => d['Excess Death Number']) < 0 && !(d3.min(graphData, d => d['Excess Death Number']) > 0)){
            graph.selectAll('.zero-divider')
            .data(yearStringStarted[yearStringStarted.length-1])
            .join('line')
            .attr('class', 'zero-divider')
            .attr('x1', 0)
            .attr('y1', y(0))
            .attr('x2', graphWidth)
            .attr('y2', y(0))
            .attr('stroke', colorZeroDivisor);
        } else {
            graph.selectAll('.zero-divider')
            .remove();
        }
        // if(d3.min(graphData, d => d['Excess Death Number']) === 0){
        //     graph.selectAll('.zero-divider')
        //     .remove();
        // }
        // else {
        //     graph.selectAll('.zero-divider')
        //     .data(yearStringStarted[yearStringStarted.length-1])
        //     .join('line')
        //     .attr('class', 'zero-divider')
        //     .attr('x1', 0)
        //     .attr('y1', y(0))
        //     .attr('x2', graphWidth)
        //     .attr('y2', y(0))
        //     .attr('stroke', colorZeroDivisor);
        // }
        
        graph.selectAll('.year-divider')
        .remove();

        graph.selectAll('.year-divider-label')
        .remove();
     }

        //line graph
        const lineGenerator = d3.line()
            .x(d => x(new Date(d.engDate)))
            .y(d => y(d['Excess Death Number']))
            .curve(d3.curveLinear);
        
        // if(selectedTimeFormat === 'เดือน' || selectedTimeFormat === 'ปี'){
        //     graph.selectAll('.datapoint')
        //     .data(graphData)
        //     .join('circle')
        //     .attr('class', 'datapoint')
        //     .attr('fill', (d, i) => colorScheme[i])
        //     .attr('r', 3)
        //     .attr('cx', d => x(new Date(d.engDate)))
        //     .attr('cy', d => y(d['Excess Death Number']));
        // }  else {
        //     graph.selectAll('.datapoint')
        //         .remove();
        // }

        graph.selectAll('.dashed,.solid')
            .data(nestedData)
            .join('path')
            .attr('class',function(d){
                if(d.SEX === 'หญิง'){
                   return 'dashed';
                } else {
                   return 'solid';
                }
             })
            .attr('stroke', (d, i) => color(d.AGE_GROUP))
            .attr('fill', 'none')
            .attr('d', d => lineGenerator(d.values))
            .on("mouseover", function(d) {
                d3.selectAll(".dashed,.solid").style("opacity", otherLinesOpacityHover);
                d3.selectAll(".datapoint_male,.datapoint_female,.datapoint_all").style("opacity", circleOpacityOnLineHover);
                d3.select(this)
                  .style("opacity", lineOpacityHover)
                  .style("stroke-width", lineStrokeHover)
                  .style("cursor", "pointer");
              })
              .on("mouseout", function(d) {
                d3.selectAll(".dashed,.solid").style("opacity", lineOpacity);
                d3.selectAll(".datapoint_male,.datapoint_female,.datapoint_all").style("opacity", circleOpacity);
                d3.select(this)
                  .style("stroke-width", lineStroke)
                  .style("cursor", "none");
              });

            graph.selectAll('.datapoint_male')
              .data(graphData)
              .join('circle')
              .attr('class', 'datapoint_male')
              .raise()
              .attr('fill', (d, i) => {if(d.SEX === 'ชาย'){  
                  return colorScheme[i];  
              } 
              else {
                  return 'white'; 
              }
              })
              .attr('r', 4.5)
              .attr('cx', d => x(new Date(d.engDate)))
              .attr('cy', d => y(d['Excess Death Number']));
  
          graph.selectAll('.datapoint_female')
              .data(graphData)
              .join('circle')
              .attr('class', 'datapoint_female')
              .raise()
              .style("stroke", (d, i) => {if(d.SEX === 'หญิง'){  
                      return colorScheme[i];  
                  } 
                  else {
                      return 'none'; 
                  }
              })
              .attr('r', 4)
              .attr('fill', (d, i) => {if(d.SEX === 'หญิง'){  
                  return 'white';  
              } 
              else {
                  return 'none'; 
              }
              })
              .style("stroke-width", lineStroke_mouse)
              .attr('cx', d => x(new Date(d.engDate)))
              .attr('cy', d => y(d['Excess Death Number']));
              
            graph.selectAll('.datapoint_all')
              .data(graphData)
              .join('circle')
              .attr('class', 'datapoint_all')
              .raise()
              .attr('fill', (d, i) => {if(d.SEX === undefined){  
                //   return colorScheme[i];
                    return 'white';  
              } else {
                  return 'none';
              }
              })
              .style("stroke", (d, i) => {if(d.SEX === undefined){ 
                        return colorScheme[i];
                    } else {
                        return 'none';
                    }
               })
               .attr('r', 4)
              .style("stroke-width", lineStroke_mouse)
              .attr('cx', d => x(new Date(d.engDate)))
              .attr('cy', d => y(d['Excess Death Number']));
               
              graph.selectAll('.datapoint_all_inner')
              .data(graphData)
              .join('circle')
              .attr('class', 'datapoint_all_inner')
              .raise()
              .attr('fill', (d, i) => {if(d.SEX === undefined){  
                  return colorScheme[i];  
              } else {
                  return 'none';
              }
              })
              .attr('r', 1.25)
              .attr('cx', d => x(new Date(d.engDate)))
              .attr('cy', d => y(d['Excess Death Number']));

        graph.selectAll(".ylabel")
        .data(nestedData_dummy)
        .join("text")
        .attr("class", "ylabel")
        .attr("text-anchor", "end")
        .attr("y", -25)
        .attr("x", 50)
        .attr("dy", ".75em")
        .attr("transform", "rotate(0)")
        .text("การตายส่วนเกิน");
        
        if(selectedTimeFormat === 'ปี'){
            graph.selectAll(".xlabel")
            .data(nestedData_dummy)
            .join("text")
            .attr("class", "xlabel")
            .attr("text-anchor", "end")
            .attr("x", graphWidth + 60)
            .attr("y", graphHeight + 5)
            .text(`เวลา (${selectedTimeFormat})`);
        } else {
            graph.selectAll(".xlabel")
            .data(nestedData_dummy)
            .join("text")
            .attr("class", "xlabel")
            .attr("text-anchor", "end")
            .attr("x", graphWidth + 90)
            .attr("y", graphHeight + 5)
            .text(`เวลา (${selectedTimeFormat})`);
        }

        mousePerLine
        .append("circle")
        .attr("r", 5.5)
        .style("stroke", (d,i) => color(d.AGE_GROUP))
        .style("fill", "none")
        .style("stroke-width", lineStroke_mouse)
        .style("opacity", "0");
        
        
        rect.attr('width', graphWidth) 
        .attr('height', graphHeight)
        .attr('fill', 'none')
        .attr('pointer-events', 'all')
        .on('mouseout', function (d) { // on mouse out hide line, circles and text
            d3.select(".mouse-line-1")
                .style("opacity", "0");
            d3.selectAll(".mouse-per-line-1 circle")
                .style("opacity", "0");
            d3.selectAll(".mouse-per-line-1 text")
                .style("opacity", "0");
            d3.selectAll("#tooltip1")
                .style('display', 'none')
        })
        .on('mouseover', function (d) { // on mouse in show line, circles and text
            d3.select(".mouse-line-1")
                .style("opacity", "3");
            d3.selectAll(".mouse-per-line-1 circle")
                .style("opacity", "1");
            d3.selectAll("#tooltip1")
                .style('display', 'block')
        })
        .on('mousemove', function (event) { // update tooltip1 content, line, circles and text when mouse moves

        var mouse = d3.pointer(event)
        

        d3.selectAll(".mouse-per-line-1")
            .attr("transform", function (d, i) {
                const data_array = d.values;
                var xDate = x.invert(mouse[0]) // use 'invert' to get date corresponding to distance from mouse position relative to svg
                var bisect = d3.bisector(function (data_array) {
                            return data_array.engDate; 
                        }).left // retrieve row index of date on parsed csv
                var idx = bisect(d.values, xDate);
            
                d3.select(".mouse-line-1")
                    .attr("d", function () {
                    if(data_array[idx] != undefined){
                        var data = "M" + x(data_array[idx].engDate) + "," + (graphHeight);
                        data += " " + x(data_array[idx].engDate) + "," + 0;
                        return data;
                    }
                });
                if(data_array[idx] != undefined){
                    d3.selectAll(".mouse-per-line-1 circle")
                    .style("opacity", "1");
                    return "translate(" + x(data_array[idx].engDate) + "," + y(data_array[idx]['Excess Death Number']) + ")";
                }
                else{
                    d3.selectAll(".mouse-per-line-1 circle")
                    .style("opacity", "0");
                    return "translate(0,0)";
                }
            });

            updateTooltipContent(event, mouse, nestedData, color, x, selectedTimeFormat);

        })

        // call axes
        xAxisGroup.call(xAxis);
        yAxisGroup.call(yAxis);

        yAxisGroup.selectAll('text')
        .attr('font-size', 12);

        xAxisGroup.selectAll('text')
            .attr('font-size', 12);
    }

    return ( 
        <div className="canvas">
            <svg ref={svgRef1} width={window.innerWidth*screen_width_fac} height={window.innerHeight*screen_height_fac}>
                <g transform="translate(50,50)">
                    <g ref={mouseGRef1} >
                        <path ref={mouseLineRef1}/>
                        <rect ref={rectRef1}/>
                    </g>
                    <g ref={xAxisRef1} className="x-axis" />
                    <g ref={yAxisRef1} className="y-axis" />
                    <g ref={graphRef1} className="graph"/>
                </g>
            </svg>
            <div ref={toolTipRef1}/>
        </div>
     );
}

// transform="translate(50,50)"
export default View3_G1;